import { createSelector, createStructuredSelector } from 'reselect';
import { flow, map, kebabCase } from 'lodash/fp';
import { groupOptions } from 'helpers/fieldOptions/car/make';
import { selectManufacturerOptions } from 'store/ducks/manufacturers';

const getOptions = createSelector(selectManufacturerOptions, (options) =>
  flow(
    map((item) => ({
      ...item,
      make: kebabCase(item.label),
    })),
    groupOptions,
  )(options),
);

export default createStructuredSelector({
  options: getOptions,
});
